import { styled } from '@mui/material/styles'
import {
  ToggleButtonGroup,
  toggleButtonGroupClasses,
  toggleButtonClasses,
  ToggleButton,
  Typography,
  Box,
  darken,
} from '@mui/material'

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  & .${toggleButtonGroupClasses.grouped} {
    margin: 0;
    border: 0;
    border-radius: 6px;

    &.${toggleButtonGroupClasses.disabled} {
      border: 0;
    }
  }

  &
    .${toggleButtonGroupClasses.middleButton},&
    .${toggleButtonGroupClasses.lastButton} {
    margin-left: 4px;
    border-left: 0;
  }
`

export const StyledToggleButton = styled(ToggleButton)`
  height: 40px;
  min-width: 36px;
  padding: 0 16px;
  background-color: transparent;
  color: ${({ theme }) => theme.palette.custom.blue2};
  text-transform: none;

  &.${toggleButtonClasses.selected} {
    background-color: ${({ theme }) => theme.palette.custom.gray4};
    color: ${({ theme }) => theme.palette.custom.blue1};

    &:hover {
      background-color: ${({ theme }) =>
        darken(theme.palette.custom.gray4, 0.025)};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.custom.gray4};
  }
`

export const StyledOption = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
`

export const SortIconWrapper = styled(Box)`
  width: 14px;
  height: 10px;
  margin-left: 10px;
  color: ${({ theme }) => theme.palette.custom.blue1};
  display: flex;
  align-items: center;
  justify-content: center;

  &.rotate {
    transform: scale(1, -1);
  }
`
